const Methods = () => {
  return (
    <>
      <h2 className='text-center mt-10 text-3xl'>Listado de Métodos de Pago</h2>
      <table className='table-fixed w-2/3 mx-auto mt-20 text-3xl'>
        <tbody>
          <tr>
            <td className='border-2 text-center'>Efectivo en Divisas</td>
          </tr>
          <tr>
            <td className='border-2 text-center'>Zelle</td>
          </tr>
          <tr>
            <td className='border-2 text-center'>Bancos Nacionales</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default Methods
